import { motion } from 'framer-motion';

const MOCK_REVIEWS = [
  { name: 'Emre N.', exam: 'YKS 2026', text: '"Sıralama sistemi sayesinde çalışmak bir oyuna dönüştü. Normalde 2 saat zor odaklanırken şimdi günlük 6 saatlere çıktım."', avatar: '👨‍🎓' },
  { name: 'Ayşe K.', exam: 'LGS 2026', text: '"Görevlerimi tamamlamak ve o XP animasyonunu görmek inanılmaz motive edici. Kesinlikle tavsiye ederim!"', avatar: '👩‍🎓' },
  { name: 'Mehmet Y.', exam: 'YKS 2026', text: '"Forum sayesinde çözemediğim soruları anında tartışabiliyorum. Beraber çalıştığımızı bilmek yalnızlık hissini bitirdi."', avatar: '👨‍🏫' }
];

export default function Testimonials() {
  return (
    <section className="testimonials-section" style={{ padding: 'var(--space-12) 0', position: 'relative', overflow: 'hidden' }}>
      
      <div className="section-header" style={{ textAlign: 'center', marginBottom: 'var(--space-8)' }}>
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Kaptanlar Ne Diyor?
        </motion.h2>
        <p className="text-secondary" style={{ fontSize: 'var(--text-lg)' }}>
          Binlerce öğrenci Yelken ile hayallerine ulaşıyor.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--space-6)', maxWidth: '1200px', margin: '0 auto' }}>
        {MOCK_REVIEWS.map((review, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            style={{
              background: 'var(--bg-glass)',
              border: '1px solid var(--border-subtle)',
              borderRadius: 'var(--radius-lg)',
              padding: 'var(--space-6)',
              position: 'relative'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', marginBottom: 'var(--space-4)' }}>
              <div style={{ fontSize: '40px', background: 'var(--bg-tertiary)', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {review.avatar}
              </div>
              <div>
                <h4 style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{review.name}</h4>
                <span style={{ fontSize: 'var(--text-xs)', color: 'var(--accent-primary)', background: 'var(--accent-glow)', padding: '2px 8px', borderRadius: 'var(--radius-full)' }}>
                  {review.exam}
                </span>
              </div>
            </div>
            <p style={{ color: 'var(--text-secondary)', fontStyle: 'italic', lineHeight: 1.6 }}>
              {review.text}
            </p>
            
            {/* Quote decoration */}
            <div style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '60px', color: 'var(--bg-tertiary)', opacity: 0.5, fontFamily: 'serif', zIndex: -1 }}>
              "
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
